/**
 * Test-login bridge route, consumes ?token=...&redirect=...
 * Stores the token, refreshes auth state, then navigates to the redirect.
 * Only reachable from the admin "Test Mode" panel.
 */
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";

export default function TestLoginPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { refresh } = useAuth();

  useEffect(() => {
    const token = params.get("token");
    const redirect = params.get("redirect") || "/";
    if (!token) {
      navigate("/admin");
      return;
    }
    (async () => {
      try {
        sessionStorage.setItem("impersonation_token", token);
        await refresh();
      } catch (err) {
        console.warn("test-login refresh failed", err);
      }
      navigate(redirect, { replace: true });
    })();
  }, [params, navigate, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center font-serif italic text-[var(--bloom-ink-muted)]">
      Opening test session...
    </div>
  );
}
